import React from "react"
import {Row} from "@irati/ui/src/Layout"
import styled from "styled-components"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"

const StyledWelcomeMessage = styled.div`
  margin: 20px 0;
`

import TextArea from "@irati/ui/src/FormItem/TextArea"

const WelcomeMessage = (props) => (
  <StyledWelcomeMessage>
    <Body small marginBottom={1} weight="bold">
      <FormattedMessage id="admin.components.welcomeMessage.title" />
    </Body>
    <Body small marginBottom={1}>
      <FormattedMessage id="admin.components.welcomeMessage.text" />
    </Body>
    <Row>
      <TextArea
        name="welcome_message"
        id="welcome_message"
        label=""
        onChange={props.updateWelcomeMessage}
        value={props.welcomeMessage}
        rows={5}
      />
    </Row>
  </StyledWelcomeMessage>
)

WelcomeMessage.propTypes = {
  updateWelcomeMessage: PropTypes.func.isRequired,
  welcomeMessage: PropTypes.string.isRequired
}

export default WelcomeMessage
